import React from "react";
import { Card, Tag, Button } from "antd";

const CourseCard = ({ classTitle, schedule, buttonLabel = "Enroll Now" }) => {
  return (
    <Card className="rounded-2xl border border-gray-200 hover:shadow-md">
      <div className="flex justify-between items-start mb-3">
        <div>
          <h3 className="text-lg font-semibold text-gray-900">{classTitle}</h3>
          <p className="text-gray-700 text-sm mt-1">
            {schedule}
          </p>
        </div>
      </div>

      <Button
        type="text"
        className="font-medium btn-gradient-emerald w-full"
      >
        {buttonLabel}
      </Button>
    </Card>
  );
};

export default CourseCard;

